import React from 'react';
import Text from '@service-victoria/component-library/components/Text';
import { ExternalLinks } from 'utils/constants';
import * as Styled from '../../../styled';

const ExemptionPreable: React.FC<Record<string, never>> = () => (
  <>
    <Styled.Spacer16 />
    <Text.Heading.H3 fontWeight={600}>
      Get your Australian Federal Government exemption first
    </Text.Heading.H3>
    <Text.Body>
      You’ll need an Australian Federal Government exemption before applying for a Victorian State
      Government exemption.
    </Text.Body>
    <Text.Body>
      Restrictions on international travel falls under the jurisdiction of the Australian Federal
      Government.
    </Text.Body>
    <Text.Body>
      To find out more, or to apply for an exemption to enter Australia, please refer to the{' '}
      <Text.Link
        target='_blank'
        href={ExternalLinks.FederalGovInternationInfo}
        value="Australian Government's Department of Health website"
      />
      .
    </Text.Body>
    <Styled.Spacer32 />
  </>
);

export default ExemptionPreable;
